export default __webpack_public_path__ + "media/0b9cce69d89fcbafd89337b0a2fbb9405e53535124a9cb63843d38f17436f328.svg";